<template lang="pug">
.form-color.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container
        input.input(v-model="dataForm.color" autocomplete="ño" :disabled="fillData" required)
        label.label(:class="{ show: dataForm.color }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="color" title="Color Ingles")

      .input-container
        input.input(v-model="dataForm.spanish" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.spanish }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="spanish" title="Color Español")

      .input-container
        input.input(v-model.number="dataForm.order" type="number" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.order  >= 0 }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="order" title="Orden")

      .input-container
        input.input(v-model="dataForm.hexadecimal" autocomplete="ño" @paste.prevent="deleteSharp('hexadecimal')" required)
        label.label(:class="{ show: dataForm.hexadecimal }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="hexadecimal" title="Hexadecimal")
        shColor(:hexadecimal="dataForm.hexadecimal")

      .left
        h3 Activo en Marca

      .input-container.arrow(v-for="(brand, index) in brands")
        select.select(v-model="dataForm.activeColor[index]" autocomplete="ño" required)
          option(:value="true") Activo
          option(:value="false") Inactivo
        label.label(:class="{ show: dataForm.activeColor[index] }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="activeColor" :index="index" :title="brand")

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteColor")
</template>

<script>
import mDB from '@/mixins/db'
import mForm from '@/mixins/form'
import gqlColor from '@/graphql/color'
import shDeleteButton from '@/components/elements/DeleteButton'
import shProperty from '@/components/elements/Property'
import shColor from '@/components/elements/Color'

export default {
  name: 'FormColor',

  mixins: [mDB, mForm],

  components: { shDeleteButton, shProperty, shColor },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        color: '',
        spanish: '',
        active: false,
        hexadecimal: '',
        activeBrands: [],
        activeColor: []
      },
      resolver: 'color',
      key: 'color',
      gql: gqlColor
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  mounted () {
    this.dataForm.activeBrands = this.brands
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newColor()
      } else {
        this.updateColor()
      }
    },

    newColor () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateColor () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteColor () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    deleteSharp (property) {
      this.dataForm[property] = event.clipboardData.getData('text').replace('#', '')
    }
  },

  computed: {
    brands () {
      return this.$store.state.variables.brands
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-color
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/color/Form.vue